import {
  AssignableTypeEnum,
  TaskableTypeEnum,
  TaskEventTypeEnum,
  UserTaskTypeEnum,
} from '../_generated/openapi';

export const TaskableType = {
  CLUB: 'App\\Models\\Base\\Club' as TaskableTypeEnum,
  BASKETBALL_TEAM:
    'App\\Models\\Basketball\\BasketballTeam' as TaskableTypeEnum,
};

export const TaskEventType = {
  BASKETBALL_GAME:
    'App\\Models\\Basketball\\BasketballGame' as TaskEventTypeEnum,
  BASKETBALL_PRACTICE:
    'App\\Models\\Basketball\\BasketballPractice' as TaskEventTypeEnum,
};

export const AssignableType = {
  USER: 'App\\Models\\Base\\User' as AssignableTypeEnum,
  BASKETBALL_TEAM:
    'App\\Models\\Basketball\\BasketballTeam' as AssignableTypeEnum,
  ALL: 'App\\Models\\Base\\Generic' as AssignableTypeEnum,
};

export const UserTaskType = {
  INVENTORY_TRANSFER_CONFIRM: 'INVENTORY_TRANSFER_CONFIRM' as UserTaskTypeEnum,
  INVENTORY_TRANSFER_RETURN: 'INVENTORY_TRANSFER_RETURN' as UserTaskTypeEnum,
  INVENTORY_TRANSFER_RETURN_CONFIRM:
    'INVENTORY_TRANSFER_RETURN_CONFIRM' as UserTaskTypeEnum,
};
